import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import { FormOptionButtonComponent } from './form-option-button.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [FormOptionButtonComponent],
  exports: [FormOptionButtonComponent]
})
export class FormOptionButtonModule {
}
